<template>
  <div class="public-card-wrapper p-4 md:p-10 flex justify-center min-h-screen">
    
    <div v-if="isLoading" class="text-xl font-semibold mt-10">Loading Talent Card...</div>
    
    <div v-else-if="userData" class="w-full max-w-4xl bg-white rounded shadow-lg talent-card-container mt-8 mb-12">
      <talent-card />
    </div>
    
    <div v-else class="text-xl font-semibold text-red-500 mt-10">
      <h2>Talent Card not found or is not published.</h2>
    </div>
    
  </div>
</template>

<script>
import TalentCard from "@/views/user-dashboard/components/TalentCard.vue"; 

export default {
  components: {
    TalentCard
  },
  data() {
    return {
      isLoading: true,
      userData: null
    };
  },
  async mounted() {
    const userId = this.$route.params.userId; 
    
    try {
      const response = await this.$http.get(`${process.env.VUE_APP_API_URL}/api/v2/user/${userId}/resume-builder`);
      
      if (response.data && response.data.status === 'success') {
        const payload = response.data.data;
        
        if (payload.userData.resumeStatus === 'published') {
          this.userData = payload.userData;
          
          // Call our bulletproof Vuex hydrator
          this.hydrateVuexSafely(payload);
        }
      }
    } catch (error) {
      console.error("Error fetching public talent card:", error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    hydrateVuexSafely(payload) {
      // 1. Ensure the modules exist (Incognito users have empty stores)
      if (!this.$store.state.users) {
        this.$store.registerModule('users', { namespaced: true, state: { data: {} } });
      }
      if (!this.$store.state.editor) {
        this.$store.registerModule('editor', { namespaced: true, state: {} });
      }

      // 2. Safely assign the data directly to bypass missing mutation crashes
      this.$store.state.users.data = payload.userData;
      
      // 3. Inject Editor Data (Crucial for Experience, Education, and Skills to show up!)
      if (payload.editorData) {
        this.$store.state.editor.educationalQualifications = payload.editorData.educationalQualifications || [];
        this.$store.state.editor.careerHistory = payload.editorData.careerHistory || [];
        this.$store.state.editor.projects = payload.editorData.projects || [];
        this.$store.state.editor.extraCurricular = payload.editorData.extraCurricular || {};
        this.$store.state.editor.personality = payload.editorData.personality || [];
      }
    }
  }
};
</script>

<style scoped>
.public-card-wrapper {
  background-color: #f8f8f8;
}

/* Forces all text inside the talent card to be left-aligned */
.talent-card-container ::v-deep * {
  text-align: left !important;
  text-justify: auto !important;
}

/* Removes Vuexy's default card margins so it looks like a clean web page */
.talent-card-container ::v-deep .vx-card {
  margin-bottom: 0 !important;
  box-shadow: none !important;
}
</style>